module.exports = __webpack_public_path__ + "public/images/explore-chemistry.2a25b44e31729272a7bbf47334b005d8.jpg";